import React, { Component } from "react";
import { connect } from "react-redux";
import { isMobile } from 'react-device-detect';
import { setYatesValue } from "../../../actions";
import { yates } from "../../../operations";
import { Body, Text, InputCleave } from '../../Common/Form';
import { Input, Select } from '../../ui';
import Continue from "../../Common/Continue";
import { 
  validateDate,
  compareDateWithToday,
  mapSelectList,
} from "../../../helpers";

import iconNumber from '../../../assets/icons/icon-number.svg';
import iconCalendar from '../../../assets/icons/icon-calendar-blue.svg';
import iconHouse from '../../../assets/icons/icon-house.svg';
import iconBoat from '../../../assets/icons/icon-embarcadiones-placer.svg';

class YateForm_3 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      continue: false,
    };

    this.continueCondition = this.continueCondition.bind(this);
    this.getColumnContent = this.getColumnContent.bind(this);
    this.evaluateDate = this.evaluateDate.bind(this);
    this.haveExtinguishers = this.haveExtinguishers.bind(this);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { getZonasResidencia } = this.props;
    getZonasResidencia();
  }

  componentDidMount() {
    this.checkContinueState(null);
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkContinueState(prevState,);
  }

  continueCondition() {

    const { 
      zonaResidencia, marina, extintores,
      extFechaExpiracion, matricula, motorNumero
    } = this.props;

    return (
      zonaResidencia != null &&
      marina != null &&
      extintores != '' &&
      extintores >= 1 &&
      this.haveExtinguishers() &&
      this.evaluateDate(extFechaExpiracion) &&
      matricula != '' &&
      motorNumero != ''
    );
  }

  checkContinueState(prevState) {
    if (this.continueCondition()) {
      if (prevState === null || !prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState === null || prevState.continue) this.setState({ continue: false });
    }
  }

  evaluateDate(date) {
    return (
      date != '' &&
      validateDate(date) &&
      compareDateWithToday(date, 'days') === 1
    );
  }

  haveExtinguishers() {
    const { extVigencia } = this.props;
    return (
      extVigencia && 
      extVigencia.value === '1'
    );
  }

  getColumnContent() {

    const { 
      zonaResidencia, showError, 
      zonasResidencia, onValueChange, 
      getMarinas, matricula, 
      marina, marinas, motorNumero, 
      extVigencia, extVigenciaOpciones, 
      extintores, extFechaExpiracion
    } = this.props;

    return (
      <div>
        <div className="Yates-formRow">
          <div style={{ flex: 1 }}>
            <Text style={{ paddingTop: '15px'}} className="Text-question">
              ¿Cual es su zona de residencia?
            </Text>
            <Select
              id="zonaResidencia"
              name="zonaResidencia"
              leftIcon={iconHouse}
              value={zonaResidencia}
              showAlert={showError && !zonaResidencia}
              onChange={(value) => {onValueChange('zonaResidencia', value); getMarinas(); }}
              //placeholder="Seleccione una zona de residencia"
              searchable={!isMobile}
              options={mapSelectList(zonasResidencia)}
              autoComplete="nope"
            />
          </div>
          <div style={{ flex: 1 }}>
            <Text style={{ paddingTop: '15px'}} className="Text-question">
              ¿Cuál es el número de matrícula?
            </Text>
            <Input
              id="matricula"
              name="matricula"
              leftIcon={iconNumber}
              value={matricula}
              showAlert={showError && !matricula}
              onChange={(event) => { onValueChange('matricula', event.target.value) }}
              //placeholder="Ingrese su número de matrícula"
              type="text"
            />
          </div>
        </div>
        <div className="Yates-formRow">
          <div style={{ flex: 1 }}>
            <Text style={{ paddingTop: '15px'}} className="Text-question">
              ¿En que marina se encuentra?
            </Text>
            <Select
              id="marina"
              name="marina"
              leftIcon={iconBoat}
              value={marina}
              showAlert={showError && !marina}
              onChange={(value) => { onValueChange('marina', value) }}
              //placeholder="Seleccione una marina"
              searchable={!isMobile}
              options={mapSelectList(marinas)}
              autoComplete="nope"
            />
          </div>
          <div style={{ flex: 1 }}>
            <Text style={{ paddingTop: '15px'}} className="Text-question">
              ¿Cuál es el detalle de motor?
            </Text>
            <Input
              id="motorNumero"
              name="motorNumero"
              leftIcon={iconBoat}
              value={motorNumero}
              showAlert={showError && !motorNumero}
              onChange={(event) => { onValueChange('motorNumero', event.target.value) }}
              //placeholder="Ingrese el detalle de motor"
              type="text"
            />
          </div>
        </div>

        <div className="Yates-formRow-2">
          <div style={{ flex: 1 }}>
            <Text style={{ paddingTop: '15px'}} className="Text-question">
              ¿Cuenta con extintores vigentes?
            </Text>
            <Select
              id="extVigencia"
              name="extVigencia"
              leftIcon={iconNumber}
              value={extVigencia}
              showAlert={showError && !this.haveExtinguishers()}
              onChange={(value) => { onValueChange('extVigencia', value) }}
              //placeholder="Marque Si o No"
              searchable={!isMobile}
              options={mapSelectList(extVigenciaOpciones)}
              autoComplete="nope"
            />
          </div>
        </div>

        <div className={!this.haveExtinguishers() ? 'Yates-formRow Price-content_disabled' : 'Yates-formRow'}>
          <div style={{ flex: 1 }}>
            <Text style={{ paddingTop: '15px'}} className="Text-question">
              ¿Cuantos extintores tiene?
            </Text>
            <Input
              id="extintores"
              name="extintores"
              leftIcon={iconNumber}
              value={this.haveExtinguishers() ? extintores : ''}
              showAlert={showError && this.haveExtinguishers() && (!extintores || extintores < 1)}
              onChange={(event) => { onValueChange('extintores', event.target.value) }}
              disabled={!this.haveExtinguishers()}
              //placeholder="Ingrese el número de extintores"
              type="number"
            />
          </div>
          <div style={{ flex: 1 }}>
            <Text style={{ paddingTop: '15px'}} className="Text-question">
              ¿Cuál es su fecha de expiración? 
            </Text>
            <InputCleave
              name="extFechaExpiracion"
              //placeholder="Fecha de expiración de los extintores"
              value={this.haveExtinguishers() ? extFechaExpiracion : ''}
              leftIcon={iconCalendar}
              disabled={!this.haveExtinguishers()}
              showAlert={showError && this.haveExtinguishers() && !this.evaluateDate(extFechaExpiracion)}
              options={{date: true, datePattern: ['d','m','Y']}}
              onChange={(event) => { onValueChange('extFechaExpiracion', event.target.value) }}
            />
          </div>
        </div>

        <div>
          <p className="Yates-placeHolder">
            Tené presente que los extintores deben encontrarse con fecha vigente de carga durante todo el período asegurado por la Póliza.
          </p>
        </div>
      </div>
    );
  }

  render() {

    const { continue: toContinue } = this.state;

    return (
      <div>
        <Text style={{ paddingTop: '25px'}} className="Text-question Text-question--bold">
          Completá los siguientes datos
        </Text>
        <Body columnContent={this.getColumnContent} />
        <Continue state={toContinue} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    showError: state.steps.showError,

    zonasResidencia: state.yates.zonasResidencia,
    marinas: state.yates.marinas,
    extVigenciaOpciones: state.yates.extVigenciaOpciones,

    zonaResidencia: state.yates.zonaResidencia,
    marina: state.yates.marina,
    extintores: state.yates.extintores,
    extVigencia: state.yates.extVigencia,
    extFechaExpiracion: state.yates.extFechaExpiracion,

    matricula: state.yates.matricula,
    motorNumero: state.yates.motorNumero,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onValueChange: (type, value) => {
      dispatch(setYatesValue(type, value));
    },
    getQuotation: () => {
      dispatch(yates.getQuotation());
    },
    getZonasResidencia: () => {
      dispatch(yates.getZonasResidencia());
    },
    getMarinas: () => {
      dispatch(yates.getMarinas());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(YateForm_3);